import React from 'react';
import { FiDroplet } from 'react-icons/fi';
import tnsLogo from '../../../assets/images/tnslogo.png';
import InsertTapCardImage from '../../../assets/images/terminal/insert-or-tap-card.png';

const OPTInsertTapCard = ({ amount, onCardDetected }) => (
  <div className="bg-white text-gray-800 h-full flex flex-col overflow-hidden">
    {/* Header */}
    <div className="flex items-center justify-between px-3 py-2 border-b border-gray-100 flex-shrink-0">
      <div className="flex items-center space-x-1.5">
        <div className="w-6 h-6 bg-blue-600 rounded-full flex items-center justify-center">
          <FiDroplet className="w-3 h-3 text-white" />
        </div>
        <span className="font-bold text-gray-800 text-xs">Fuel Co</span>
      </div>
      <div className="flex items-center space-x-1">
        <span className="text-[10px] text-gray-400">Powered by</span>
        <img src={tnsLogo} alt="TNS" className="h-4" />
      </div>
    </div>

    {/* Content */}
    <div className="flex-1 flex flex-col items-center justify-center px-3 py-2">
      <div className="text-2xl font-bold text-gray-900 mb-3">${amount || '0.00'}</div>
      <img 
        src={InsertTapCardImage} 
        alt="Tap or insert card" 
        className="w-28 h-28 object-contain mb-2"
      />
      <div className="text-sm text-gray-600 mb-3">Tap or insert card</div>
      <button 
        onClick={onCardDetected}
        className="px-8 py-2.5 bg-green-600 text-white font-bold text-sm rounded-lg hover:bg-green-700 transition-colors"
      >
        CONTINUE
      </button>
    </div>
  </div>
);

export default OPTInsertTapCard;
